import {gql} from '@apollo/client';
import type {Bookmark} from 'types';
import type {AdminError} from 'graphql/admin';
import {BOOKMARK_FRAGMENT} from './AdminBookmarkFragments';

export enum CreateBookmarkError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  FOLDER_ERROR = 'FOLDER_ERROR',
  EMPTY_FIELD = 'EMPTY_FIELD',
}

export const CREATE_BOOKMARK_MUTATION = gql`
  mutation CreateBookmark($createBookmarkInput: CreateBookmarkInput!) {
    createBookmark(createBookmarkInput: $createBookmarkInput) {
      __typename
      ... on CreateBookmarkOutput {
        bookmark {
          ...Bookmark
        }
      }
      ... on CreateBookmarkErrorOutput {
        errorReason
      }
    }
  }
  ${BOOKMARK_FRAGMENT}
`;

export type CreateBookmarkOutput = {
  createBookmark: {
    errorReason?: CreateBookmarkError;
    bookmark: Bookmark;
  };
};

export const UPDATE_BOOKMARK_MUTATION = gql`
  mutation UpdateBookmark($updateBookmarkInput: UpdateBookmarkInput!) {
    updateBookmark(updateBookmarkInput: $updateBookmarkInput) {
      __typename
      ... on UpdateBookmarkOutput {
        bookmark {
          ...Bookmark
        }
      }
      ... on UpdateBookmarkErrorOutput {
        errorReason
      }
    }
  }
  ${BOOKMARK_FRAGMENT}
`;

export enum UpdateBookmarkError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  FOLDER_ERROR = 'FOLDER_ERROR',
  EMPTY_FIELD = 'EMPTY_FIELD',
  NOT_FOUND = 'NOT_FOUND',
  BOOKMARK_LOCKED = 'BOOKMARK_LOCKED',
}

export type UpdateBookmarkOutput = {
  updateBookmark: {
    errorReason?: UpdateBookmarkError;
    bookmark: Bookmark;
  };
};

export const DELETE_BOOKMARKS_MUTATION = gql`
  mutation DeleteBookmarks($deleteBookmarksInput: DeleteBookmarksInput!) {
    deleteBookmarks(deleteBookmarksInput: $deleteBookmarksInput) {
      __typename
      ... on DeleteBookmarksOutput {
        successes
        failures {
          subject
          reason
        }
      }
      ... on DeleteBookmarksQueryErrorOutput {
        errorReason
      }
    }
  }
`;

export enum DeleteBookmarksError {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  NOT_FOUND = 'NOT_FOUND',
  DELETE = 'DELETE',
  BOOKMARK_LOCKED = 'BOOKMARK_LOCKED',
}

export type DeleteBookmarksOutput = {
  deleteBookmarks: {
    errorReason?: AdminError;
    failures: {
      subject: string;
      reason: DeleteBookmarksError;
    }[];
    successes: string[];
  };
};
